import {
  SET_ALERT_OPEN,
  SET_MOB_SIDE_NAV_BAR_VISIBILITY,
  SET_FILTERS_VISIBILITY,
} from '../actions/types';

const initialState = {
  isAlertOpen: false,
  alertType: 'success',
  alertMessage: null,
  showMobSideNavBar: false,
  isFiltersOpen: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ALERT_OPEN:
      return {
        ...state,
        ...payload,
      };

    case SET_MOB_SIDE_NAV_BAR_VISIBILITY:
      return {
        ...state,
        showMobSideNavBar: payload,
      };

    case SET_FILTERS_VISIBILITY:
      return {
        ...state,
        isFiltersOpen: payload,
      };

    default:
      return state;
  }
}
